/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { ReactComponent as ComposeIcon } from 'assets/icons/compose.svg'
import Space from 'material/space/space';
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './messagetoendusers_styles'
import PreviewConfig from '../../previewconfig/previewconfig';
import { TextAreaField, TextField, InlineMessage } from '@insticator/insticator-ui/dist/material';
import MarkdownPreview from 'material/markdownpreview/markdownpreview';


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : MESSAGE TO END-USERS ~~~~~~~~~~ ========== */
const MessageToEndUsers = injectSheet(styles)((props) => {

  const { useCustomMessage, customMessageBody, onChange  } = props

  return (
    <SectionGroupV2 klass={`messagetoendusers ${props.classes.messagetoendusers}`} title={'Message to End-Users'} description={`Speak directly to your end-users to keep them updated on important information.`} rowGap={32} direction={'column'}>
      <ConfigToggle 
        title={'Enable message'}
        description={'Inform users of community guidelines, upcoming product changes, and more.'}
        checked={useCustomMessage}
        onChange={val => onChange('useCustomMessage', val)}
      >
        <Space gap={48}>
          <Space direction={'column'}>
            {/* <TextField 
              type={`text`} 
              name={`heading`} 
              icon={<ComposeIcon />}
              label={'Heading'}
              value={message.heading} 
              handleChange={e => setMessage({...message, heading: e.target.value})}
              placeholder={`Enter message heading`} 
              maxLength={20}
            /> */}
            <TextAreaField
              type={'textarea'}
              name={'clientMessage'}
              icon={<ComposeIcon />}
              label={'Message'}
              required={true}
              value={customMessageBody}
              handleChange={e => onChange('customMessageBody', e.target.value)}
              placeholder={'Enter the message'}
              maxLength={5000}
              valid={useCustomMessage ? !!customMessageBody : true}
            />
             <InlineMessage
              key={'meow'}
              display={true}
              name={'headercode'}
              variant={'neutral'}
              icon={'exclamation-triangle'}
              title={null}
              message={<span className='client-message-notification'>
                This textbox supports markdown syntax for 
                {' '}<a href='https://www.markdownguide.org/basic-syntax/#headings' target='_blank'>headings</a>, 
                {' '}<a href='https://www.markdownguide.org/basic-syntax/#bold' target='_blank'>bold</a>, 
                {' '}<a href='https://www.markdownguide.org/basic-syntax/#italic' target='_blank'>italics</a>, and 
                {' '}<a href='https://www.markdownguide.org/basic-syntax/#links' target='_blank'>links</a>.
              </span>}
              close={false}
              handleClose={null}
            />
          </Space>
          <PreviewConfig>
            <div className='messagetoenduserspreview'>
              <MarkdownPreview
                isV2={true}
                heading={''}
                value={customMessageBody || ''}
              />
            </div>
          </PreviewConfig>
        </Space>
      </ConfigToggle>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MessageToEndUsers;